import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from '../../../shared/base.page';
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { UIService } from '../../../shared/services/UIService';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';


@Component({
    templateUrl: './templates.page.html',
})

export class TemplatesPage extends BasePage {

    dataBases: any[] = [];

    sourceDb: string;
    targetDb: string;


    loadParams: any = {
        ID: null
    };

    items: any[] = [
        {
            title: 'Distribute selected forms',
            name: 'copy',
            class: 'success',
            icon: 'fa fa-copy',
        },
    ]

    @ViewChild('grid') grid: DxDataGridComponent;
    @ViewChild('frmReset') form: DxValidationGroupComponent;
    loadingVisible: boolean = false;



    constructor(public router: Router, serviceCaller: ServiceCaller, public ui: UIService) {
        super(serviceCaller);

        serviceCaller.get('/Company/Installed/List').then(c => {
            this.dataBases = c;
        });
    }

    onMenuItemClick(e) {
        switch (e.name) {
            case 'copy':
                {

                    if (this.form.instance.validate()) {


                        if (this.grid.instance.getSelectedRowKeys().length < 1) {
                            this.ui.error('Please select at least one form');
                            return;
                        }
                        if (this.sourceDb == null || this.targetDb == null) {
                            this.ui.error('Please select source and target databases');
                            return;
                        }
                        this.ui.custom('Distribute forms', 'Are you sure you want to distribute the selected forms?', [
                            {
                                name: 'locked',
                                text: 'Copy as locked',
                                type: 'success',
                            },
                            {
                                name: 'version',
                                text: 'Copy as new vesrion',
                                type: 'default',
                            }
                        ]).then((res) => {
                            debugger;
                            this.loadingVisible = true;
                            if (res && res.name) {
                                this.api.post('/Form/Copy', {
                                    sourceDbId: this.sourceDb,
                                    TargetDbIds: [this.targetDb],
                                    FormIds: this.grid.instance.getSelectedRowKeys(),
                                    locked: res.name === 'locked'
                                }).then(c => {
                                    this.ui.success();
                                    this.loadingVisible = false;
                                }).catch(() => {
                                    this.loadingVisible = false;
                                });
                            }
                        });
                    }
                    break;
                }
        }
    }

    handleSourceChange(e) {
        this.loadParams = {
            ID: this.sourceDb
        }
        this.grid.instance.refresh();
    }


}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Settings/templates.page.ts